import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpreakerComponent } from './simple-icons-spreaker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpreakerComponent ],
    exports:      [ SimpleIconsSpreakerComponent ],
    bootstrap:    []
})
export class SimpleIconsSpreakerModule {}
